import jquery from './jquery-1.9.0.min';
import layerModule from "./layer";
import Glide from '@glidejs/glide'

(()=>{
  const mvGlide = new Glide('.main_visual', {
      type: 'carousel',
      startAt: 0,
      perView: 1,
      autoplay: 5000,
  });

  mvGlide.on('mount.after', function() {
    //console.log(glide);
    //console.log(glide._c.Html.slides.length);
    const total = mvGlide._c.Html.slides.length;
    $('.glide__number .glide_total').html(total);
  });

  mvGlide.on(['mount.after', 'run.after'], function() {
      //console.log(glide.index);
      let num = "09";
      $('.glide__number .glide_current').html(mvGlide.index+1);
  });

  const ssGlide = new Glide('.sytm_slide', {
      type: 'carousel',
      startAt: 0,
      perView: 1
  });

  mvGlide.mount();
  ssGlide.mount();

  new Glide('#y2019 .pf_slide', {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    peek: {
        // gap: 300,
        before: 0,
        after: 0
    },
    breakpoints: {
      767: {
        startAt: 0,
        peek: {
          before: 0,
          after: 25
        }
      }
    }
  }).mount();

  $('.btnLink').click(function(){
    var tab_id = $(this).attr('data-type');

    $('.btnLink').removeClass('on');
    $('.js_tabCon').removeClass('on');
    $(this).addClass('on');
    let tabCon = $("#" + tab_id);
    tabCon.addClass('on');

    if(!tabCon.hasClass('active')){
      tabCon.addClass('active');
      let sliderTxt = "#" + tab_id + " .pf_slide";
      new Glide(sliderTxt, {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        peek: {
            // gap: 300,
            before: 0,
            after: 0
        },
        breakpoints: {
          767: {
            startAt: 0,
            peek: {
              before: 0,
              after: 25
            }
          }
        }
      }).mount();
    }
  });

})();

$(document).ready(function(){

  let link = $('.js_scrl_gnb li a');

  link.on('click',function(e){
    //href 속성을 통해, section id 타겟을 잡음
    let target = $($(this).attr('href'));

    //target section의 좌표를 통해 꼭대기로 이동
    $('html, body').animate({
        scrollTop: target.offset().top
    },600);

    //on 클래스 부여
    $(this).parent().addClass('on');

    //앵커를 통해 이동할때, URL에 #id가 붙지 않도록 함.
    e.preventDefault();
    gnbClose();
  });

  $(window).on('scroll',function(){
      findPosition();
  });

  function findPosition(){
    $('.section').each(function(){
        if( ($(this).offset().top - $(window).scrollTop() ) < 20){
            link.parent().removeClass('on');
            $('.js_scrl_gnb').find('[data-scroll="'+ $(this).attr('id') +'"]').parent().addClass('on');
        }
    });
  }

  findPosition();

  //download 버튼
  let downPath = 'http://shop.witplus.com/download/';

  $(".btn_pdf").click(function(){
    // download();

    // function download(){

      // if($("input[name='btn_type']").is(":checked") == true){
      //   console.log("what" + this);

      //   if ($("input").val)

      //   let url = contextPath + this.value;
      //   location.href = url;
      // }
      $("input[name=btn_type]:checked").each(function(){
        let ipVal = $(this).val();
        console.log($(this));
        onclick = location.href = downPath + ipVal;
      });
    // }
  });

  //top 버튼
  let $btnTop = $(".btn_top");

  $btnTop.on("click", function(){
    $('html, body').stop().animate({scrollTop:0}, 800);
  });

  //웹 모바일 구분
  let mbActive = false,
      screenSize = parseInt($(this).width());

  function mbGNB(){
    //모바일 gnb
    $(".btn_gnb").on("click", function(){
      $('.mb_logo h1').removeClass("on");
      $(".gnb_area").show();
      $(".gnb_area .tbl").stop().animate({"right":"0"}, 500);
    });

    //모바일 down
    $(".btn_dMenu").on("click", function () {
      $(".dMenu_area").show();
      $(".dMenu_area").stop().animate({ "bottom": "0" }, 500);
    });
  }

  function gnbClose(){
    $(".gnb_area .tbl").stop().animate({"right":"-100%"}, 500);
    $(".dMenu_area").stop().animate({"bottom":"-100%"}, 500);

    setTimeout(function() {
      $(".gnb_area").hide();
      $(".dMenu_area").hide();
    }, 1000);
  }

  $(".btn_close").on("click", function(){
    gnbClose();
  });

  if(768 > screenSize){
      //MB
      mbGNB();
      gnbClose();
      mbActive = false;
  }else if(768 <= screenSize){
      //PC
      mbActive = true;
  }
  $(window).bind('resize', function(){
      let reSize = parseInt($(this).width());
      if( 768 > reSize && mbActive == true){
          //MB
          mbActive = false;
          mbGNB();
          gnbClose();
      }else if(768 <= reSize && mbActive == false){
          //PC
          mbActive = true;
      }
  });
});

//mblogo
$(function(){
  let mbLogo = $('.mb_logo .logo'),
      mbList = $('.mb_logo .logo_box');
  
  $(mbLogo).on("click" , function(){
      $(this).addClass("on");
  })
})
// quickOpen
$(function(){
  let quickOpen = $('.quick_open .quick_open'),
      quickWrap = $('.quick_list');

  $(quickOpen).on('click' , function(){
    $(this).toggleClass('on');
    $(quickWrap).toggleClass('on');
  })
})
